import abbreviateBigNumber from "src/helpers/abbreviateBigNumber";
import { radiusLarge, radiusMedium } from "src/styles/radius";
import { paddingLarge, paddingSmall } from "src/styles/spacing";
import { BlurView, Text } from "src/swsh-native";
import AnimatedSelectionWrapper from "./components/AnimatedSelectionWrapper";
import ReactionAssetDisplay from "./components/ReactionAssetDisplay";
import { ReactionBadgeProps } from "./types";

const ReactionBadge = ({
	reactionAsset,
	sizeVariant = "md",
	count,
	isSelected,
}: ReactionBadgeProps) => {
	const borderRadius = sizeVariant === "md" ? radiusLarge : radiusMedium;
	const ReactionDisplay = (
		<ReactionAssetDisplay sizeVariant={sizeVariant} reactionAsset={reactionAsset} />
	);
	return (
		<BlurView
			testID={`ReactionBadge-${isSelected ? "selected" : "unselected"}`}
			style={[
				{
					alignItems: "center",
					flexDirection: "row",
					columnGap: paddingSmall,
					borderRadius,
					overflow: "hidden",
				},
				sizeVariant === "md" && {
					height: 40,
					paddingHorizontal: paddingLarge,
				},
				sizeVariant === "sm" && {
					height: 24,
					paddingHorizontal: 12,
				},
			]}
		>
			{isSelected != null ? (
				<AnimatedSelectionWrapper isSelected={isSelected} borderRadius={borderRadius}>
					{ReactionDisplay}
				</AnimatedSelectionWrapper>
			) : (
				ReactionDisplay
			)}
			{count != null && (
				<Text semibold={sizeVariant === "md"} xs={sizeVariant === "sm"}>
					{abbreviateBigNumber(count)}
				</Text>
			)}
		</BlurView>
	);
};
export default ReactionBadge;
